import axios from 'axios'
import { BUSCAR_PESSOA_REMETENTE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { apenasNumero } from '../../util/inputs';

export default function buscarPessoaRemetentePorCpfCnpj (cpfCnpj) {
  const cpfCnpjSemFormatacao = apenasNumero(cpfCnpj)
  const url = `${URL}/pessoas/cpf-cnpj/${cpfCnpjSemFormatacao}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_PESSOA_REMETENTE,
        payload: response

      })
  );
}
